import React from 'react';
import ErrorsReport from './ErrorsReport';

export default ErrorsReport;
